import {
	IState,
	SubjectStateResponse,
	AuthKeys,
	SetStateResponse,
	GetStateRequest,
	SetValueRefResponse,
	GetStateRefRequest,
	GetValueRefResponse,
	ValueListRefResponse,
	VersionListResponse,
	ResponseWitOutData,
	SetValueRefRequest,
	GetValueListRequest,
	FileType,
} from '../types';
import { fetchData } from '../fetchService';
import { toSearchParams } from '../helpers/common';

const stateService = {
	async set<T>(
		baseUrl: string,
		object: string,
		data: IState<T>,
		authKeys?: AuthKeys,
	): Promise<SetStateResponse> {
		return await fetchData(
			`${baseUrl}/state?object=${object}`,
			'POST',
			data,
			authKeys,
		);
	},
	async setValueRef(
		baseUrl: string,
		data: SetValueRefRequest,
		file: FileType,
		authKeys?: AuthKeys,
	): Promise<SetValueRefResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/value${query ? `?${query}` : ''}`,
			'POST',
			file,
			authKeys,
		);
	},
	async get<T>(
		baseUrl: string,
		data: GetStateRequest,
		authKeys?: AuthKeys,
	): Promise<SubjectStateResponse<T>> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/state${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
	async getValueRef(
		baseUrl: string,
		data: GetStateRefRequest,
		authKeys?: AuthKeys,
	): Promise<GetValueRefResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/value${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
			{ 'x-bs-stream': '1' },
		);
	},
	async deleteValueRef(
		baseUrl: string,
		data: GetStateRefRequest,
		authKeys?: AuthKeys,
	): Promise<ResponseWitOutData> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/value${query ? `?${query}` : ''}`,
			'DELETE',
			data,
			authKeys,
		);
	},
	async getVersionList(
		baseUrl: string,
		object: string,
		authKeys?: AuthKeys,
	): Promise<VersionListResponse> {
		return await fetchData(
			`${baseUrl}/version?object=${object}`,
			'GET',
			null,
			authKeys,
		);
	},
	async getRefList(
		baseUrl: string,
		data: GetValueListRequest,
		authKeys?: AuthKeys,
	): Promise<ValueListRefResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/value/match${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
};

export default stateService;
